<script>
	import SkContent from "./SkContent.svelte"
					
  
  import { redirect } from "../../pager";
  import { fade } from "svelte/transition";  
  //liblary 
  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
 
</script>
<svelte:head>
  <title>Syarat & Ketentuan Dekatan</title>
</svelte:head>
<main transition:fade  class="container px-2 pt-16 mx-auto mb-5" style="">
   
  <div class="max-w-4xl px-3 py-5 mx-auto bg-white rounded-lg">
    
  <div class="justify-center mb-2 font-bold">
    <img on:click={()=>redirect('/')}
      src="./assets/logo/logo.svg" width="274" height="64"
      alt="logo"
      class="h-20 py-2 bg-white rounded-lg shadow-lg cursor-pointer" />
  </div>
    <div class="p-10 mx-auto text-sm text-justify"><SkContent/>
    </div>
  </div>
</main> 
